import React from "react";
import { observer } from "mobx-react";
import type { WalletStore } from "../../stores/wallet/wallet-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import { Toggle } from "../../../../components/inputs/toggle/toggle";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import ConfirmDisableAutoChargeModal from "./confirm-disable-auto-charge-modal";
import { ButtonIcon } from "../../../../components/inputs/button-icon/button-icon";
import IconEdit from "../../../../components/icons/icon-edit/icon-edit";
import "./wallet-status.scss";
import AutoRechargeSettingsModal from "./auto-recharge-settings-modal";
import AddCreditsModal from "./add-credits-modal";
import WalletStatusBar from "./wallet-status-bar";

interface Props {
    walletStore: WalletStore;
}

const WalletStatus: React.FC<Props> = observer(({walletStore} :Props) => {
    return (
        <div className="wallet-status">
            <div className="wallet-status-container">
                <FontBody2 variant={FONT_VARIANT.BOLD}>Wallet Status</FontBody2>
                <WalletStatusBar walletStore={walletStore} />
                <div className={"wallet-status-auto-recharge-line"}>
                    <FontBody2 color={FONT_COLOR.PRIMARY2}>Auto Recharge</FontBody2>
                    <div className={"wallet-status-auto-recharge-toggle"}>
                        <Toggle onChange={walletStore.toggleAutoRecharge} checked={walletStore.isAutoRechargeEnabled} label={''} />
                        <ButtonIcon onClick={() => walletStore.setShouldShowAutoRechargeSettingsModal(true)} Component={() => <IconEdit color={'var(--color-accent-1)'}/>} />
                    </div>
                </div>
            </div>
            
            {walletStore.shouldShowDisableAutoRechargeConfirmModalOpen && <ConfirmDisableAutoChargeModal store={walletStore} onCloseClick={() => walletStore.setShouldShowDisableAutoRechargeConfirmModalOpen(false)} />}
            {walletStore.shouldShowAutoRechargeSettingsModal && <AutoRechargeSettingsModal walletStore={walletStore} onCloseClick={() => walletStore.setShouldShowAutoRechargeSettingsModal(false)} />}
            {walletStore.shouldShowAddCreditsModal && <AddCreditsModal walletStore={walletStore} onCloseClick={() => walletStore.setShouldShowAddCreditsModal(false)} />}
        </div>
    );
});

export default WalletStatus;